<template>
  <div id="app">
    <loading v-if="loading"></loading>
    <keep-alive>
      <router-view v-if='$route.meta.keepAlive'/>
    </keep-alive>
      <router-view v-if='!$route.meta.keepAlive'/>

    <!-- <router-view /> -->
  </div>
</template>



<script>
import { mapGetters } from "vuex";
import * as types from "@/store/types";
import Loading from "./base/loading/Loading";


export default {
  name: "App",
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getTimeObj",
      "getUserList",
      "getToken",
      "getSocketToken",
      "getChannel",
      "getCode",
      "getLoginObj",
      "getAppFlag",
    ])
  },
  components: {
    Loading
  },
  created() {
    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload", () => {
      localStorage.setItem("messageStore", JSON.stringify(this.$store.state));
    });

    //在页面加载时读取localStorage里的状态信息
    localStorage.getItem("messageStore") &&
      this.$store.replaceState(
        Object.assign(
          this.$store.state,
          JSON.parse(localStorage.getItem("messageStore"))
        )
      );

    //cnzz
    const script = document.createElement('script')  
    script.src = `https://s4.cnzz.com/z_stat.php?id=1278662762&web_id=1278662762`  
    script.language = 'JavaScript'  
    document.body.appendChild(script)  



  },
   watch: {  
    '$route': {
      handler(to, from) {
        setTimeout(() => { //避免首次获取不到window._czc
          if (window._czc) {  
            let location = window.location; 
            let contentUrl = location.pathname + location.hash;  
            let refererUrl = '/';  
            // 用于发送某个URL的PV统计请求，
            window._czc.push(['_trackPageview', contentUrl, refererUrl])  
          }
        }, 300) 
      },
      immediate: true  // 首次进入页面即执行
    }  
  }
};

window.onload = function() {
 document.addEventListener('touchstart', function(event) {
 if (event.touches.length > 1) {
  event.preventDefault()
 }
 })
 document.addEventListener('gesturestart', function(event) {
 event.preventDefault()
 })
}

</script>

<style>
body {
  margin: 0px;
}

.w-head {
  display: block;
  box-sizing: border-box;
}

.w-page {
  display: block;
  height: 100%;
  position: relative;
  height: calc(100% - 44px);
  height: calc(100% - 44px - constant(safe-area-inset-top));
  height: calc(100% - 44px - env(safe-area-inset-top));
  padding-top: 44px;
}

.w-foot {
  box-sizing: border-box;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 998;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
img{
   content: normal !important;
}
 button{
   outline:none;
  }
  input{
     outline:none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue